import { render, staticRenderFns } from "./CopyElement.vue?vue&type=template&id=1994570d&scoped=true"
import script from "./CopyElement.vue?vue&type=script&lang=js"
export * from "./CopyElement.vue?vue&type=script&lang=js"
import style0 from "./CopyElement.vue?vue&type=style&index=0&id=1994570d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994570d",
  null
  
)

export default component.exports